import {
    FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_REQUEST,
    FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_SUCCESS,
    FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_FAILURE,
  } from "./FetchExternalPractitionerAutoCompleteTypes";
  
  const initialState = {
    loading: false,
    externalPractitionersAutoComp: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_SUCCESS:
        return {
          loading: false,
          externalPractitionersAutoComp: action.payload,
          error: "",
        };
      case FETCH_EXTERNAL_PRACTITIONER_AUTO_COMPLETE_FAILURE:
        return {
          loading: false,
          externalPractitionersAutoComp: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  